import { BLU_POINTS_PARTNER_ID } from "src/app/modules/call-center/models/call-center";
import { getReportInfoFromCode } from "src/app/modules/reporting/models/report";
import {
  AsyncReport,
  AsyncReportStatus,
} from "src/app/modules/reporting/reports/async/models/async-report";
import { AsyncReportService } from "src/app/modules/reporting/reports/async/services/async-report.service";
import { BLU_NETWORK_ID } from "src/app/shared/general/constants";
import { CatalogItem } from "../models/catalogs";
import { PopupNotification } from "../models/notifications";

export function getDefaultNetworkValue(networks: CatalogItem[]) {
  if (networks.length > 0) {
    const isDefaultNetworkFoundInNetworkList = networks.find(
      (network) => network.id === BLU_NETWORK_ID,
    );
    if (isDefaultNetworkFoundInNetworkList) {
      return BLU_NETWORK_ID;
    } else if (networks?.length) {
      return networks[0]?.id;
    } else {
      return null;
    }
  }
  return null;
}

export function getDefaultPartnerValue(partners: CatalogItem[]) {
  if (partners.length > 0) {
    const isDefaultPartnerFoundInNetworkList = partners.find(
      (partner) => partner.id === BLU_POINTS_PARTNER_ID,
    );
    if (isDefaultPartnerFoundInNetworkList) {
      return BLU_NETWORK_ID;
    } else if (partners?.length) {
      return partners[0]?.id;
    } else {
      return null;
    }
  }
  return null;
}

export function isReportGenerated(status: AsyncReportStatus) {
  return status === AsyncReportStatus.GENERATED;
}

export function isReportFailed(status: AsyncReportStatus) {
  return status === AsyncReportStatus.FAILED;
}

export function createPopupNotificationForAsyncReport(
  report: AsyncReport,
  asyncReportService: AsyncReportService,
): PopupNotification {
  const asyncReport = getReportInfoFromCode(report.code);
  const reportName = asyncReport?.nameInNotification
    ? asyncReport.nameInNotification
    : asyncReport?.name;
  return {
    id: report.id,
    isRead: false,
    label: `The ${reportName} report is ready, click here to view`,
    action: () => {
      asyncReportService.redirectToReport(report.code);
    },
  };
}
